<template>

    <ActionCombo item-text="shortname" :noBorder="noBorder" :noClearable="noClearable" :placeholder="placeholder" :skeleton="compSkeleton" :disabled="compDisabled" :rules="rules" v-model="dvalue" :items="vatlist"></ActionCombo>

</template>

<script setup>

    // import VatCombo from '@controls/combo/Vat'
    //            <VatCombo :disabled="model.disabled" :rules="model.rules.id_vat" v-model="model.id_vat"></VatCombo>
    // or:        <VatCombo :model="model" :rules="model.rules.id_vat" v-model="model.id_vat"></VatCombo>

    const props = defineProps({
        disabled: {
            type: [Boolean]
        },
        rules: {
            type: [Array]
        },
        noClearable: {
            type: [Boolean],
            default: false
        },
        noBorder: {
            type: [Boolean]
        },
        skeleton: {
            type: [Boolean]
        },
        value: {
            type: [String, Number]
        },
        standardTypes: {
            type: [Boolean]
        },
        sales: {
            type: [Boolean]
        },
        purchase: {
            type: [Boolean]
        },
        placeholder: {
            type: [String],
            default: 'BTW'
        },
        model: {
            type: [Object]
        }

    })
    
    import ActionCombo from '@controls/combo/ActionCombo'
    import {vat as items} from '@app/list';
    import {computed} from 'vue'

    const emit = defineEmits(['input'])

    const dvalue = computed({
        get() {
            return props.value
        },
        set: function(v) {
            emit('input', v)
        }	
    })
    const vatlist = computed({
        get() {
            if (props.standardTypes) {
                return items.standardTypes();
            }
            if (props.sales) {
                return items.sales();
            }
            if (props.purchase) {
                return items.purchase();
            }
            return items.list;
        }
    });
    const compSkeleton = computed({
        get() {
            if (props.skeleton) {
                return true;
            }
            if (!props.model) {
                return false;
            }
            return props.model.isDataLoading;
        }
    });
    const compDisabled = computed({
        get() {
            if (props.disabled) {
                return true;
            }
            if (!props.model) {
                return false;
            }
            return props.model.disabled;
        }
    });

</script>
